export const slideShowNL = {
	slideshow: null,
	currentSlide: 1,
	slides: [],
	biModal: null,
	swipeX: null,
	swipeY: null,
	swipeThreshold: 50,
	touchLock: false,

	init(slideshow) {
		this.configureSlideshow(slideshow);
		this.setBiModal(slideshow);
		this.addListeners(slideshow);
		this.toggleButtons();

		/**
		 * see top comment
		 */
		// if (window.location.hash) {
		// this.setSlideByHash(slideshow);
		// this.openModal();
		// }
	},

	configureSlideshow(slideshow) {
		this.slideshow = slideshow;
		this.slides = jQuery(slideshow).find('.slideshow__list-item');
	},

	setBiModal(slideshow) {
		const modal = jQuery(slideshow).parents('.modal');

		if (
			modal.length > 0 &&
			Object.prototype.hasOwnProperty.call(
				window.biModalList,
				jQuery(modal).data('name'),
			)
		) {
			this.biModal = window.biModalList[jQuery(modal).data('name')];
		}
	},

	startTouch(e) {
		this.swipeX = e.originalEvent.touches[0].clientX;
		this.swipeY = e.originalEvent.touches[0].clientY;
		this.touchLock = true;
	},

	touchMove(e) {
		if (!this.touchLock) {
			return;
		}

		const currentX = e.originalEvent.changedTouches[0].clientX;
		const currentY = e.originalEvent.changedTouches[0].clientY;

		const diffX = this.swipeX - currentX;
		const diffY = this.swipeY - currentY;

		if (Math.abs(diffX) > Math.abs(diffY)) {
			// sliding horizontally
			if (diffX > 0) {
				// swiped left
				e.preventDefault();
			} else {
				e.preventDefault();
			}
		} else {
			// sliding vertically
			if (diffY > 0) {
				return;
			}
			return;
		}

		// calculate how big % the amount moved pixels is of the ul
		// diffX / ulwidth / 100

		const slideNr = this.currentSlide - 1;
		const jQueryslideshowList = jQuery(this.slideshow).find('.slideshow__list');
		const placement =
			slideNr * 100 + diffX / (jQueryslideshowList.outerWidth() / 100);

		if (placement > (this.slides.length - 1) * 100) {
			return;
		}
		jQueryslideshowList.addClass('slideshow__list--scrolling');
		jQueryslideshowList.css('transform', 'translateX(-' + placement + '%)');
	},

	touchEnd(e) {
		this.touchLock = false;
		const self = this;
		if (this.swipeX === null || this.swipeY === null) {
			return false;
		}

		const currentX = e.originalEvent.changedTouches[0].clientX;
		const currentY = e.originalEvent.changedTouches[0].clientY;

		const diffX = this.swipeX - currentX;
		const diffY = this.swipeY - currentY;

		const jQueryslideshowList = jQuery(this.slideshow).find('.slideshow__list');
		jQueryslideshowList.removeClass('slideshow__list--scrolling');

		if (diffX > 0 && diffX < this.swipeThreshold) {
			this.showSlide(this.currentSlide);
			return;
		}

		if (diffX < 0 && diffX > -this.swipeThreshold) {
			this.showSlide(this.currentSlide);
			return;
		}

		if (Math.abs(diffX) > Math.abs(diffY)) {
			// sliding horizontally
			if (diffX > this.swipeThreshold) {
				// swiped left
				self.plusSlide(1);
				e.preventDefault();
			}

			if (diffX < -this.swipeThreshold) {
				// swiped right
				self.plusSlide(-1);
				e.preventDefault();
			}
		}

		this.swipeX = null;
		this.swipeY = null;
	},

	openModal() {
		if (!this.biModal) {
			return false;
		}
		this.biModal.openModal();
	},

	/**
	 * set correct slide based on hash in url
	 * The element ID is prefixed to prevent scrolling to element in the browser when hash is changed.
	 */

	setSlideByHash() {
		const self = this;
		const anchor = window.location.hash;
		this.slides.each(function (index, slide) {
			if (jQuery(slide).attr('id') === anchor.replace('#S', '')) {
				self.showSlide(index + 1);
			}
		});
	},

	addListeners(slideshow) {
		const self = this;

		// keyboard navigation
		jQuery('body').keydown(function (event) {
			//check if slideshow is active.
			if (!self.biModal.isOpen()) {
				return;
			}

			switch (event.which) {
				case 37:
					self.plusSlide(-1); // arrow left
					break;
				case 39:
					self.plusSlide(1); //arrow right
					break;
				case 27:
					self.biModal.closeModal(); // esc button
			}
		});

		// next button
		jQuery(self.biModal.modal)
			.find('.slideshow-modal__nav-button--next')
			.on('click', function () {
				self.plusSlide(1);
			});

		// back button
		jQuery(self.biModal.modal)
			.find('.slideshow-modal__nav-button--prev')
			.on('click', function () {
				self.plusSlide(-1);
			});

		jQuery(slideshow).on('touchstart', function (e) {
			self.startTouch(e);
		});

		jQuery(slideshow).on('touchmove', function (e) {
			self.touchMove(e);
		});

		jQuery(slideshow).on('touchend', function (e) {
			self.touchEnd(e);
		});

		if (this.biModal) {
			this.biModal.modal.addEventListener('modalOpen', function (elem) {
				self.setSlideHeight(slideshow);

				//set focus on first triggerable element
				jQuery(elem.target)
					.find('.slideshow__list-item--active')
					.find('a, button')
					.first()
					.focus();
			});
		}
	},

	plusSlide(n) {
		this.showSlide(this.currentSlide + n);
		this.toggleButtons();
	},

	toggleButtons() {
		const self = this;
		const firstSlide = 1;
		const lastSlide = this.slides.length;
		const prevButton = jQuery(self.biModal.modal).find(
			'.slideshow-modal__nav-button--prev',
		);
		const nextButton = jQuery(self.biModal.modal).find(
			'.slideshow-modal__nav-button--next',
		);

		if (this.currentSlide === firstSlide) {
			prevButton.addClass('disabled');
			nextButton.removeClass('disabled');
		} else if (this.currentSlide === lastSlide) {
			prevButton.removeClass('disabled');
			nextButton.addClass('disabled');
		} else {
			prevButton.removeClass('disabled');
			nextButton.removeClass('disabled');
		}
	},

	showSlide(n) {
		const self = this;
		if (n > this.slides.length) {
			// at the end of loop do nothing
			return false;
		}

		if (n < 1) {
			// at the beginning of loop do nothing
			return false;
		}

		// reset all slides
		this.slides.each(function (index, slide) {
			self.makeSlideInactive(slide);
		});

		// make slide active
		const slideNr = n - 1;
		jQuery(this.slideshow)
			.find('.slideshow__list')
			.css('transform', 'translateX(-' + slideNr + '00%)');
		this.makeSlideActive(this.slides[slideNr]);

		/**
		 * see top comment
		 */
		// this.setUrlhash(jQuery(this.slides[slideNr]).attr('id'));

		if (this.biModal) {
			this.updateSlideCount(n);
		}

		this.refreshAds();

		self.setSlideHeight(self.slideshow);

		this.currentSlide = n;
	},

	makeSlideInactive(element) {
		jQuery(element)
			.removeClass('slideshow__list-item--active')
			.addClass('slideshow__list-item--inactive');
		jQuery(element).find('button', 'a').attr('tabindex', -1);
	},

	makeSlideActive(element) {
		jQuery(element).addClass('slideshow__list-item--active');
		jQuery(element).removeClass('slideshow__list-item--inactive');
		jQuery(element).find('button', 'a').attr('tabindex', 0);
	},

	updateSlideCount(n) {
		jQuery(this.biModal.modal).find('.slideshow-modal__count').text(n);
	},

	setSlideHeight(slideshow) {
		jQuery(slideshow)
			.find('.slideshow__list')
			.css(
				'max-height',
				jQuery(slideshow)
					.find('.slideshow__list-item--active .slideshow__slide')
					.height() + 'px',
			);
	},

	refreshAds() {
		if (googletag.pubads === 'function') {
			googletag.pubads().refresh([gptadslots[11]]);
			googletag.pubads().refresh([gptadslots[12]]);
		}
	},
};
